module.exports = __webpack_public_path__ + "static/media/video_thumb2.8b4c1117.png";